import api from "../index";

// Create an onboarding subscription
export const createOnboardingSubscription = async (data: any) => {
  return await api.post("/subscriptions/onboarding", data);
};

// Create a subscription
export const createSubscription = async (data: any) => {
  return await api.post("/subscriptions/subscribe", data);
};

// Manage a subscription
export const manageSubscription = async () => {
  return await api.get("/subscriptions/manage");
};

// Handle free plan subscription
export const handleFreePlanSubscription = async () => {
  return await api.post("/subscriptions/free-plan");
};
